<script lang="ts">
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import SettingsActivityTypesFragment from "./SettingsActivityTypesFragment.svelte";
  import SettingsClfFragment from "./SettingsClfFragment.svelte";
  import SettingsDossierCategoriesFragment from "./SettingsDossierCategoriesFragment.svelte";
  import SettingsActivityCategoriesFragment from "./SettingsActivityCategoriesFragment.svelte";
  import SettingsDossierTypesFragment from "./SettingsDossierTypesFragment.svelte";
  import SettingsGeneralFragment from "./SettingsGeneralFragment.svelte";

  enum SettingPage {
    General = 1,
    Classifications,
    DossierCategories,
    ActivityCategories,
    DossierTypes,
    ActivityTypes,
  }

  let currentTab: SettingPage = SettingPage.General;
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == SettingPage.General}
      on:click={(_) => {
        currentTab = SettingPage.General;
      }}
    />
    <Tab
      label="Tabelle"
      active={currentTab == SettingPage.Classifications}
      on:click={(_) => {
        currentTab = SettingPage.Classifications;
      }}
    />
    <Tab
      label="Categorie Pratica"
      active={currentTab == SettingPage.DossierCategories}
      on:click={(_) => {
        currentTab = SettingPage.DossierCategories;
      }}
    />
    <Tab
      label="Categorie Attività"
      active={currentTab == SettingPage.ActivityCategories}
      on:click={(_) => {
        currentTab = SettingPage.ActivityCategories;
      }}
    />
    <Tab
      label="Tipi Pratica"
      active={currentTab == SettingPage.DossierTypes}
      on:click={(_) => {
        currentTab = SettingPage.DossierTypes;
      }}
    />
    <Tab
      label="Tipi Attività"
      active={currentTab == SettingPage.ActivityTypes}
      on:click={(_) => {
        currentTab = SettingPage.ActivityTypes;
      }}
    />
  </Tabs>

  {#if currentTab == SettingPage.General}
    <SettingsGeneralFragment />
  {/if}

  {#if currentTab == SettingPage.Classifications}
    <SettingsClfFragment />
  {/if}

  {#if currentTab == SettingPage.DossierCategories}
    <SettingsDossierCategoriesFragment />
  {/if}

  {#if currentTab == SettingPage.ActivityCategories}
    <SettingsActivityCategoriesFragment />
  {/if}

  {#if currentTab == SettingPage.DossierTypes}
    <SettingsDossierTypesFragment />
  {/if}

  {#if currentTab == SettingPage.ActivityTypes}
    <SettingsActivityTypesFragment />
  {/if}
</MainLayout>
